module.exports = __webpack_public_path__ + "img/thumbnail6.58494e17.jpg";